<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="mx-auto" color="grey lighten-4">
          <v-card-title>
            <v-row align="start">
              <div class="caption grey--text text-uppercase">
                Sales by month
              </div>
            </v-row>
          </v-card-title>

          <v-sheet color="transparent">
            <v-sparkline
              :smooth="1"
              :gradient="['#f72047', '#ffd200', '#1feaea']"
              :line-width="1"
              :value="payments"
              :labels="labels"
              label-size="3"
              auto-draw
              stroke-linecap="round"
            ></v-sparkline>
          </v-sheet>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-card class="mx-auto" color="grey lighten-4">
          <v-card-title>
            <v-icon
              :color="checking ? 'red lighten-2' : 'indigo'"
              class="mr-12"
              size="64"
            >
              shopping_cart
            </v-icon>
            <v-row align="start">
              <div class="caption grey--text text-uppercase">
                For confirmation
              </div>
              <div>
                <span
                  class="display-3 font-weight-black"
                  v-text="ordersForConfirmation"
                ></span>
              </div>
            </v-row>

            <v-spacer></v-spacer>

            <v-btn icon class="align-self-start" size="28" to="/order-confirm">
              <v-icon>mdi-arrow-right-thick</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="mx-auto" color="grey lighten-4">
          <v-card-title>
            <v-icon
              :color="checking ? 'red lighten-2' : 'indigo'"
              class="mr-12"
              size="64"
            >
              send
            </v-icon>
            <v-row align="start">
              <div class="caption grey--text text-uppercase">For Dispatch</div>
              <div>
                <span
                  class="display-3 font-weight-black"
                  v-text="ordersForDispatch"
                ></span>
              </div>
            </v-row>

            <v-spacer></v-spacer>

            <v-btn icon class="align-self-start" size="28" to="/order-dispatch">
              <v-icon>mdi-arrow-right-thick</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="mx-auto" color="grey lighten-4">
          <v-card-title>
            <v-icon
              :color="checking ? 'red lighten-2' : 'indigo'"
              class="mr-12"
              size="64"
            >
              mdi-currency-usd-off
            </v-icon>
            <v-row align="start">
              <div class="caption grey--text text-uppercase">
                Pending Payment
              </div>
              <div>
                <span
                  class="display-3 font-weight-black"
                  v-text="ordersForPayment"
                ></span>
              </div>
            </v-row>

            <v-spacer></v-spacer>

            <v-btn icon class="align-self-start" size="28" to="/order-search">
              <v-icon>mdi-arrow-right-thick</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="4">
        <v-card class="mx-auto" color="grey lighten-4">
          <v-card-title>
            <v-icon
              :color="checking ? 'red lighten-2' : 'indigo'"
              class="mr-12"
              size="64"
            >
              mdi-currency-usd
            </v-icon>
            <v-row align="start">
              <div class="caption grey--text text-uppercase">This Month</div>
              <div>
                <span
                  class="display-3 font-weight-black"
                  v-text="currMonthAmt"
                ></span>
              </div>
            </v-row>

            <v-spacer></v-spacer>

            <v-btn
              icon
              class="align-self-start"
              size="28"
              to="/payments-overview"
            >
              <v-icon>mdi-arrow-right-thick</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="mx-auto" color="grey lighten-4">
          <v-card-title>
            <v-icon
              :color="checking ? 'red lighten-2' : 'indigo'"
              class="mr-12"
              size="64"
            >
              mdi-checkbox-multiple-blank-circle-outline
            </v-icon>
            <v-row align="start">
              <div class="caption grey--text text-uppercase">This Month</div>
              <div>
                <span
                  class="display-3 font-weight-black"
                  v-text="currMonthOrders"
                ></span>
              </div>
            </v-row>

            <v-spacer></v-spacer>

            <v-btn icon class="align-self-start" size="28" to="/order-confirm">
              <v-icon>mdi-arrow-right-thick</v-icon>
            </v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import cartApi from "../modules/cart-api";
import orderAnalytics from "../modules/orderAnalytics";

const exhale = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default {
  data: () => ({
    checking: false,
    heartbeats: [],
    payments: [],
    labels: [],
    ordersForConfirmation: 0,
    ordersForDispatch: 0,
    ordersForPayment: 0,
    currMonthAmt: 0,
    currMonthOrders: 0,
  }),

  created() {
    this.getOrderForConfirmationCount();
    this.getOrderForDispatchCount();
    this.getOrdersAwaitingPayment();
    this.getPaymentHistory();
  },

  methods: {
    async getPaymentHistory() {
      let currYear = new Date().toJSON().substring(0, 4);

      // Add zero point
      const decLastYear = currYear - 1 + "-12";
      this.payments.push(0);
      this.labels.push(decLastYear);

      const paymentResults = await orderAnalytics.getPaymentHistory(currYear);

      paymentResults.ordersByMonth.forEach(monthResult => {
        this.payments.push(monthResult.orderValue);
        this.labels.push(monthResult.month);
        if (monthResult.month === paymentResults.currMonth) {
          this.currMonthAmt = monthResult.orderValue;
          this.currMonthOrders = monthResult.orderCount;
        }
      });
    },
    getOrderForConfirmationCount() {
      cartApi.getOrdersConfirmation().then((orders) => {
        this.ordersForConfirmation = orders.length;
      });
    },
    getOrderForDispatchCount() {
      cartApi.getOrdersDispatch().then((orders) => {
        this.ordersForDispatch = orders.length;
      });
    },
    getOrdersAwaitingPayment() {
      cartApi.getOrdersAwaitingPayment().then((orders) => {
        this.ordersForPayment = orders.length;
      });
    },
  },
};
</script>
